/**
 * Helpers for the "select event" blocking flow.
 * - `eventCatalogSiteLink` comes from module config.
 * - Empty string means the feature is disabled.
 */
export function getTrimmedEventCatalogSiteLink(moduleConfig: unknown): string {
    if (moduleConfig === null || moduleConfig === undefined || typeof moduleConfig !== 'object') {
        return '';
    }

    const raw = (moduleConfig as { eventCatalogSiteLink?: unknown }).eventCatalogSiteLink;
    return typeof raw === 'string' ? raw.trim() : '';
}

/** Select-event blocking modal: enabled only when `eventCatalogSiteLink` is configured. */
export function isSelectEventPopupEnabled(moduleConfig: unknown): boolean {
    return getTrimmedEventCatalogSiteLink(moduleConfig).length > 0;
}

/** Whether current page URL has a `catalogid` query param (browser only; false if unreadable). */
export function isCurrentPageHasCatalogIdParam(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    try {
        const decodedUrl = decodeURIComponent(window.location.href);
        const searchParams = new URL(decodedUrl).searchParams;
        return !!searchParams.get('catalogid');
    } catch (error) {
        console.error('Failed to read catalog id from url', error);
        return false;
    }
}
